import React from "react";

const SideCell: React.FC<{
  value: string | null | undefined;
}> = React.memo(({ value }) => {
  const formattedValue = value === "ask" ? "SELL" : "BUY";

  return (
    <p
      className={`pulse-typography-body-1 ${
        formattedValue === "SELL"
          ? "pulse-color--error-300"
          : "pulse-color--success-300"
      }`}
    >
      {formattedValue}
    </p>
  );
});

export default SideCell;
